import PasswordField from "@components/primitives/PasswordField";
import { FormControl } from "@ui/components/forms/form-control/FormControl";
import { FormErrorMessage } from "@ui/components/forms/form-control/FormError";
import { FormLabel } from "@ui/components/forms/form-control/FormLabel";

type Props = {
    error?: string;
    touched: boolean;
    label: string;
    description: string;
};

export const Password = ({ error, label, touched, description }: Props) => {
    return (
        <FormControl isRequired isInvalid={(!!error && touched) as boolean}>
            <FormLabel htmlFor="password" id="passwordLabel">
                {label}
            </FormLabel>
            <PasswordField id="password" ariaLabelledBy="passwordLabel" />
            <FormLabel fontSize="desktopBodyTextTiny" fontWeight="normal">
                {description}
            </FormLabel>
            <FormErrorMessage>{error?.toString()}</FormErrorMessage>
        </FormControl>
    );
};
